import { ReactComponent as BubbleShapeIcon } from '../assets/graphics/svg/colorable/BubbleShape_Game.svg';
import { ReactComponent as BubbleShapeShowIcon } from '../assets/graphics/svg/colorable/BubbleShape_Show.svg';
import { ReactComponent as CircleTickBlueIcon } from '../assets/graphics/svg/colorable/circle_tick_colorable.svg';
import { ReactComponent as CircleTickIcon } from '../assets/graphics/svg/colorable/circle_tick_colorable2.svg';
import { ReactComponent as ClockIcon } from '../assets/graphics/svg/colorable/clock.svg';
import { ReactComponent as TriangleIcon } from '../assets/graphics/svg/colorable/cloud_but_triangle_white.svg';
import { ReactComponent as BookGameIcon } from '../assets/graphics/svg/colorable/cloud_icon_book_game_line.svg';
import { ReactComponent as BrainIcon } from '../assets/graphics/svg/colorable/cloud_icon_brain_airevision_line_.svg';
import { ReactComponent as PersonIcon } from '../assets/graphics/svg/colorable/cloud_icon_circle_referred_User.svg';
import { ReactComponent as ContentIcon } from '../assets/graphics/svg/colorable/cloud_icon_content_description_line.svg';
import { ReactComponent as ConvertBookIcon } from '../assets/graphics/svg/colorable/cloud_icon_convert_book.svg';
import { ReactComponent as CopyIcon } from '../assets/graphics/svg/colorable/cloud_icon_copy_line.svg';
import { ReactComponent as RubbishBinIcon } from '../assets/graphics/svg/colorable/cloud_icon_delete_line.svg';
import { ReactComponent as FamilyIcon } from '../assets/graphics/svg/colorable/cloud_icon_family_line.svg';
import { ReactComponent as StarIcon } from '../assets/graphics/svg/colorable/cloud_icon_favourite_line.svg';
import { ReactComponent as DoublePersonIcon } from '../assets/graphics/svg/colorable/cloud_icon_friends_line_.svg';
import { ReactComponent as GameConversionIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_conversion_line.svg';
import { ReactComponent as JourneyIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_Set_album_line.svg';
import { ReactComponent as GameTypeFingerWritingClickComponentIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_finger_writing_click_component_line.svg';
import { ReactComponent as GameTypeFingerWritingComponentIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_finger_writing_component_line.svg';
import { ReactComponent as WritingJoyIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_finger_writing_line.svg';
import { ReactComponent as GameTypeFingerWritingStrokeIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_finger_writing_stroke_line.svg';
import { ReactComponent as QuickMemoryJoyIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_JOYApassage_line.svg';
import { ReactComponent as GameTypeSyllableIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_spell_syllable_line.svg';
import { ReactComponent as SpellingJoyIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_spelling_line.svg';
import { ReactComponent as TranslationIcon } from '../assets/graphics/svg/colorable/cloud_icon_game_type_translation_line.svg';
import { ReactComponent as SettingIcon } from '../assets/graphics/svg/colorable/cloud_icon_gear01_line.svg';
import { ReactComponent as GuranteeIcon } from '../assets/graphics/svg/colorable/cloud_icon_gurantee_line.svg';
import { ReactComponent as HappyIcon } from '../assets/graphics/svg/colorable/cloud_icon_happy_line.svg';
import { ReactComponent as HyperLinkIcon } from '../assets/graphics/svg/colorable/cloud_icon_hyperlink_line.svg';
import { ReactComponent as ImproveIcon } from '../assets/graphics/svg/colorable/cloud_icon_improve_score_line.svg';
import { ReactComponent as CashIcon } from '../assets/graphics/svg/colorable/cloud_icon_joy_cash_web_line.svg';
import { ReactComponent as JoyStationIcon } from '../assets/graphics/svg/colorable/cloud_icon_JoyStation_line.svg';
import { ReactComponent as LockIcon } from '../assets/graphics/svg/colorable/cloud_icon_lock_line.svg';
import { ReactComponent as SignUpIcon } from '../assets/graphics/svg/colorable/cloud_icon_login_line.svg';
import { ReactComponent as AiIcon } from '../assets/graphics/svg/colorable/cloud_icon_memory_ai_line.svg';
import { ReactComponent as MemoryHelperIcon } from '../assets/graphics/svg/colorable/cloud_icon_memory_helper_line.svg';
import { ReactComponent as MiniTargetIcon } from '../assets/graphics/svg/colorable/cloud_icon_mini_target_line.svg';
import { ReactComponent as MoreIcon } from '../assets/graphics/svg/colorable/cloud_icon_more_line.svg';
import { ReactComponent as PracticeTickIcon } from '../assets/graphics/svg/colorable/cloud_icon_practice_tick_line.svg';
import { ReactComponent as RecentArrowIcon } from '../assets/graphics/svg/colorable/cloud_icon_recent_arrow_line.svg';
import { ReactComponent as ReferralIcon } from '../assets/graphics/svg/colorable/cloud_icon_referral_line.svg';
import { ReactComponent as SearchWhiteIcon } from '../assets/graphics/svg/colorable/cloud_icon_search_white.svg';
import { ReactComponent as ShareIcon } from '../assets/graphics/svg/colorable/cloud_icon_share_out_line.svg';
import { ReactComponent as SuggestedWordIcon } from '../assets/graphics/svg/colorable/cloud_icon_suggested_word_line.svg';
import { ReactComponent as SuperTargetIcon } from '../assets/graphics/svg/colorable/cloud_icon_super_target_line.svg';
import { ReactComponent as TTSIcon } from '../assets/graphics/svg/colorable/cloud_icon_TTS_line.svg';
import { ReactComponent as WebStoreBasketIcon } from '../assets/graphics/svg/colorable/cloud_icon_web_store_line.svg';
import { ReactComponent as ArrowIcon } from '../assets/graphics/svg/colorable/cloud_skin02_but_arrow_set4s_00.svg';
import { ReactComponent as CrossIcon } from '../assets/graphics/svg/colorable/cross-svgrepo-com.svg';
import { ReactComponent as GameInstructionIcon } from '../assets/graphics/svg/colorable/Game_information_line.svg';
import { ReactComponent as PersonLineIcon } from '../assets/graphics/svg/colorable/personIconLine.svg';
import { ReactComponent as ScoreAnalysisIcon } from '../assets/graphics/svg/colorable/report_icon_score_analysis_line.svg';
import { ReactComponent as ScrollArrowIcon } from '../assets/graphics/svg/colorable/scrollTopArrow.svg';
import { ReactComponent as QuestionHelpIcon } from '../assets/graphics/svg/colorable/setting_page_icon_help_line.svg';
import { ReactComponent as LogoutIcon } from '../assets/graphics/svg/colorable/setting_page_icon_logout_line.svg';
import { ReactComponent as TimerIcon } from '../assets/graphics/svg/colorable/setting_page_icon_time_management_line.svg';
import { ReactComponent as DoubleClockIcon } from '../assets/graphics/svg/colorable/setting_page_icon_total_usage_time_line.svg';
import { ReactComponent as BibleIcon } from '../assets/graphics/svg/icons/bibleIcon.svg';
import { ReactComponent as CircleCheckboxEmptyIcon } from '../assets/graphics/svg/icons/button_circle_empty.svg';
import { ReactComponent as SquareCheckboxEmptyIcon } from '../assets/graphics/svg/icons/button_square_empty.svg';
import { ReactComponent as SquareCheckboxTickIcon } from '../assets/graphics/svg/icons/button_square_tick_ddgreen.svg';
import { ReactComponent as ClockRefillIcon } from '../assets/graphics/svg/icons/ClockRefill.svg';
import { ReactComponent as PlayIcon } from '../assets/graphics/svg/icons/cloud_but_play_line.svg';
import { ReactComponent as PlayerPauseIcon } from '../assets/graphics/svg/icons/cloud_but_player_pause.svg';
import { ReactComponent as PlayerPlayIcon } from '../assets/graphics/svg/icons/cloud_but_player_play.svg';
import { ReactComponent as PlayerStopIcon } from '../assets/graphics/svg/icons/cloud_but_player_stop.svg';
import { ReactComponent as RetryIcon } from '../assets/graphics/svg/icons/cloud_but_retry_line.svg';
import { ReactComponent as RotateIcon } from '../assets/graphics/svg/icons/cloud_but_rotate_line.svg';
import { ReactComponent as BrainX9Icon } from '../assets/graphics/svg/icons/cloud_icon_ai_create_game_line.svg';
import { ReactComponent as DirectArrowIcon } from '../assets/graphics/svg/icons/cloud_icon_arrow_white.svg';
import { ReactComponent as AutoSelectIcon } from '../assets/graphics/svg/icons/cloud_icon_auto_select_line.svg';
import { ReactComponent as BibleLineIcon } from '../assets/graphics/svg/icons/cloud_icon_bible_line.svg';
import { ReactComponent as BreadDonateIcon } from '../assets/graphics/svg/icons/cloud_icon_bread_donate_line.svg';
import { ReactComponent as CameraIcon } from '../assets/graphics/svg/icons/cloud_icon_camera_line.svg';
import { ReactComponent as CircleBackIcon } from '../assets/graphics/svg/icons/cloud_icon_circle_back_shade.svg';
import { ReactComponent as CircleCrossIcon } from '../assets/graphics/svg/icons/cloud_icon_circle_cross.svg';
import { ReactComponent as MemberIcon } from '../assets/graphics/svg/icons/cloud_icon_classroom_joined_line_.svg';
import { ReactComponent as ClassroomIcon } from '../assets/graphics/svg/icons/cloud_icon_classroom_line.svg';
import { ReactComponent as MembershipTierIcon } from '../assets/graphics/svg/icons/cloud_icon_classroom_membershipTier_paid_line_.svg';
import { ReactComponent as ClickIcon } from '../assets/graphics/svg/icons/cloud_icon_click_line.svg';
import { ReactComponent as CircleCheckboxTickIcon } from '../assets/graphics/svg/icons/cloud_icon_confirm_ddgreen.svg';
import { ReactComponent as CropIcon } from '../assets/graphics/svg/icons/cloud_icon_crop_line.svg';
import { ReactComponent as RedCrossIcon } from '../assets/graphics/svg/icons/cloud_icon_cross.svg';
import { ReactComponent as EditIcon } from '../assets/graphics/svg/icons/cloud_icon_edit_line.svg';
import { ReactComponent as MagnifyingMinusIcon } from '../assets/graphics/svg/icons/cloud_icon_enlarge_magnifying_minus_line.svg';
import { ReactComponent as MagnifyingPlusIcon } from '../assets/graphics/svg/icons/cloud_icon_enlarge_magnifying_plus_line.svg';
import { ReactComponent as FriendIcon } from '../assets/graphics/svg/icons/cloud_icon_friends_line_.svg';
import { ReactComponent as GameTypeFiveLoavesTwoFishIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_5_loaves_2_fish_line.svg';
import { ReactComponent as GameTypeGomokuIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_gomoku_line.svg';
import { ReactComponent as PuzzleJOYIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_image_puzzle_JOY_line.svg';
import { ReactComponent as GameTypeJoychessIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_joychess_line.svg';
import { ReactComponent as HeadphoneIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_listening_line.svg';
import { ReactComponent as GameTypeTicTacToeIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_tic_tac_toe_line.svg';
import { ReactComponent as TextJOYIcon } from '../assets/graphics/svg/icons/cloud_icon_game_type_word_guess_JOY_line.svg';
import { ReactComponent as GameIcon } from '../assets/graphics/svg/icons/cloud_icon_games_line.svg';
import { ReactComponent as HandPickFillIcon } from '../assets/graphics/svg/icons/cloud_icon_hand_pick_fill_line.svg';
import { ReactComponent as JOYCashWebIcon } from '../assets/graphics/svg/icons/cloud_icon_joy_cash_web_line.svg';
import { ReactComponent as JOYAJOYLogoHomeIcon } from '../assets/graphics/svg/icons/cloud_icon_JOYAJOY_logo_home_line.svg';
import { ReactComponent as LanguageAIcon } from '../assets/graphics/svg/icons/cloud_icon_language_a_line.svg';
import { ReactComponent as LanguageQIcon } from '../assets/graphics/svg/icons/cloud_icon_language_q_line.svg';
import { ReactComponent as MemoryWithAIIcon } from '../assets/graphics/svg/icons/cloud_icon_memory_ai_line.svg';
import { ReactComponent as MemoryWithoutAIIcon } from '../assets/graphics/svg/icons/cloud_icon_memory_without_ai_line.svg';
import { ReactComponent as MoveIcon } from '../assets/graphics/svg/icons/cloud_icon_move_line.svg';
import { ReactComponent as OCRScanIcon } from '../assets/graphics/svg/icons/cloud_icon_OCR_scan_line.svg';
import { ReactComponent as PhoneIcon } from '../assets/graphics/svg/icons/cloud_icon_phone.svg';
import { ReactComponent as PictureIcon } from '../assets/graphics/svg/icons/cloud_icon_picture_line.svg';
import { ReactComponent as GamifiedPostIcon } from '../assets/graphics/svg/icons/cloud_icon_post_gamified_line_.svg';
import { ReactComponent as PreviewHideIcon } from '../assets/graphics/svg/icons/cloud_icon_preview_hide_line.svg';
import { ReactComponent as PreviewShowIcon } from '../assets/graphics/svg/icons/cloud_icon_preview_line.svg';
import { ReactComponent as BubbleIndicatorIcon } from '../assets/graphics/svg/icons/cloud_icon_progress_indicator_shape.svg';
import { ReactComponent as ReferralRoleIcon } from '../assets/graphics/svg/icons/cloud_icon_referral_role_line.svg';
import { ReactComponent as RegionIcon } from '../assets/graphics/svg/icons/cloud_icon_region_line.svg';
import { ReactComponent as RenameIcon } from '../assets/graphics/svg/icons/cloud_icon_rename_line.svg';
import { ReactComponent as RepeatIcon } from '../assets/graphics/svg/icons/cloud_icon_repeat_line.svg';
import { ReactComponent as WarningIcon } from '../assets/graphics/svg/icons/cloud_icon_report_problem_line.svg';
import { ReactComponent as ScoreAIcon } from '../assets/graphics/svg/icons/cloud_icon_scoreA.svg';
import { ReactComponent as SelectAllIcon } from '../assets/graphics/svg/icons/cloud_icon_select_all_line.svg';
import { ReactComponent as SelectSuggestIcon } from '../assets/graphics/svg/icons/cloud_icon_select_suggest_line.svg';
import { ReactComponent as ProfitsIcon } from '../assets/graphics/svg/icons/cloud_icon_support_cause_line.svg';
import { ReactComponent as TickIcon } from '../assets/graphics/svg/icons/cloud_icon_tick.svg';
import { ReactComponent as DoubleScoreIcon } from '../assets/graphics/svg/icons/cloud_icon_total_score_line.svg';
import { ReactComponent as TutorGamesIcon } from '../assets/graphics/svg/icons/cloud_icon_tutor_games_line.svg';
import { ReactComponent as WebHomeIcon } from '../assets/graphics/svg/icons/cloud_icon_web_home_line.svg';
import { ReactComponent as ProgressArrowIcon } from '../assets/graphics/svg/icons/cloud_icon_web_progress_arrow_line.svg';
import { ReactComponent as RegisterIcon } from '../assets/graphics/svg/icons/cloud_icon_web_register_line.svg';
import { ReactComponent as WalletIcon } from '../assets/graphics/svg/icons/cloud_icon_web_wallet_line.svg';
import { ReactComponent as WordSuggestIcon } from '../assets/graphics/svg/icons/cloud_icon_word_suggest_line.svg';
import { ReactComponent as ScoreIcon } from '../assets/graphics/svg/icons/cloud_scoreboard_game_line.svg';
import { ReactComponent as Arrow5Icon } from '../assets/graphics/svg/icons/cloud_skin02_but_arrow_set5.svg';
import { ReactComponent as CompleteIcon } from '../assets/graphics/svg/icons/complete.svg';
import { ReactComponent as ConfirmTickIcon } from '../assets/graphics/svg/icons/Game_tick_confrim_line.svg';
import { ReactComponent as PeriodIcon } from '../assets/graphics/svg/icons/report_icon_period_line.svg';
import { ReactComponent as StorageIcon } from '../assets/graphics/svg/icons/storage.svg';
import { ReactComponent as SubscriptionUpgradeIcon } from '../assets/graphics/svg/icons/subsciption_upgrade.svg';
import { ReactComponent as SubscriptionIcon } from '../assets/graphics/svg/icons/subscription.svg';
import { ReactComponent as UpgradeIcon } from '../assets/graphics/svg/icons/upgrade.svg';

export enum SVGIconType {
  JOYAJOYLogoHome = 'JOYAJOYLogoHome',

  PuzzleJOY = 'PuzzleJOY',
  TextJOY = 'TextJOY',

  Region = 'Region',
  Member = 'Member',
  Friend = 'Friend',
  MembershipTier = 'MembershipTier',

  GamifiedPost = 'GamifiedPost',
  BubbleShape = 'BubbleShape',
  BubbleShapeShow = 'BubbleShapeShow',

  Arrow = 'Arrow',
  Triangle = 'Triangle',
  Referral = 'Referral',
  GameInstruction = 'GameInstruction',
  Setting = 'Setting',
  MiniTarget = 'MiniTarget',
  More = 'More',
  RecentArrow = 'RecentArrow',
  Share = 'Share',
  SuggestedWord = 'SuggestedWord',
  SuperTarget = 'SuperTarget',
  Score = 'Score',
  SignUp = 'SignUp',
  Logout = 'Logout',
  Timer = 'Timer',

  JOYChess = 'JOYChess',
  FiveLoavesTwoFish = 'FiveLoavesTwoFish',
  TicTacToe = 'TicTacToe',
  Gomoku = 'Gomoku',
  Conversion = 'Conversion',

  Ai = 'Ai',
  Gurantee = 'Gurantee',
  Star = 'Star',
  BookGame = 'BookGame',
  QuickMemoryJoy = 'QuickMemoryJoy',
  SpellingJoy = 'SpellingJoy',
  WritingJoy = 'WritingJoy',
  GameTypeSyllable = 'GameTypeSyllable',
  GameTypeFingerWritingComponent = 'GameTypeFingerWritingComponent',
  GameTypeFingerWritingClickComponent = 'GameTypeFingerWritingClickComponent',
  GameTypeFingerWritingStroke = 'GameTypeFingerWritingStroke',
  ScoreAnalysis = 'ScoreAnalysis',
  Translation = 'Translation',
  TTS = 'TTS',
  Upgrade = 'Upgrade',
  SubscriptionUpgrade = 'SubscriptionUpgrade',
  Improve = 'Improve',
  Family = 'Family',
  Cash = 'Cash',
  Happy = 'Happy',
  Person = 'Person',

  BrainX9 = 'BrainX9',
  LanguageA = 'LanguageA',
  LanguageQ = 'LanguageQ',
  OCRScan = 'OCRScan',
  Camera = 'Camera',
  Picture = 'Picture',
  Edit = 'Edit',
  Click = 'Click',
  SelectAll = 'SelectAll',
  SelectSuggest = 'SelectSuggest',
  TutorGames = 'TutorGames',
  Journey = 'Journey',
  Arrow5 = 'Arrow5',
  BubbleIndicator = 'BubbleIndicator',
  SquareCheckboxEmpty = 'SquareCheckboxEmpty',
  SquareCheckboxTick = 'SquareCheckboxTick',
  CircleCheckboxEmpty = 'CircleCheckboxEmpty',
  CircleCheckboxTick = 'CircleCheckboxTick',
  Tick = 'Tick',
  CircleCross = 'CircleCross',
  DirectArrow = 'DirectArrow',
  MemoryWithoutAI = 'MemoryWithoutAI',
  MemoryWithAI = 'MemoryWithAI',
  Play = 'Play',
  Period = 'Period',
  PlayerPause = 'PlayerPause',
  PlayerPlay = 'PlayerPlay',
  PlayerStop = 'PlayerStop',
  DoubleClock = 'DoubleClock',
  DoubleScore = 'DoubleScore',
  CircleBack = 'CircleBack',
  Game = 'Game',
  CircleTickBlue = 'CircleTickBlue',
  CircleTick = 'CircleTick',
  ConfirmTick = 'ConfirmTick',
  RedCross = 'RedCross',
  DoublePerson = 'DoublePerson',
  Retry = 'Retry',
  Repeat = 'Repeat',
  Rotate = 'Rotate',
  Crop = 'Crop',
  Move = 'Move',
  MagnifyingMinus = 'MagnifyingMinus',
  MagnifyingPlus = 'MagnifyingPlus',
  PreviewHide = 'PreviewHide',
  PreviewShow = 'PreviewShow',
  Content = 'Content',
  Cross = 'Cross',
  JOYCashWeb = 'JOYCashWeb',
  Headphone = 'Headphone',
  JoyStation = 'JoyStation',
  SearchWhite = 'SearchWhite',
  Classroom = 'Classroom',
  ScrollArrow = 'ScrollArrow',
  Phone = 'Phone',
  ConvertBook = 'ConvertBook',
  RubbishBin = 'RubbishBin',
  Lock = 'Lock',
  WebStoreBasket = 'WebStoreBasket',
  ReferralRole = 'ReferralRole',
  Brain = 'Brain',
  Clock = 'Clock',
  ProgressArrow = 'ProgressArrow',
  Complete = 'Complete',
  ScoreA = 'ScoreA',
  PracticeTick = 'PracticeTick',
  Bible = 'Bible',
  BibleLine = 'BibleLine',
  WebHome = 'WebHome',
  Wallet = 'Wallet',
  Subscription = 'Subscription',
  Storage = 'Storage',
  BreadDonate = 'BreadDonate',
  HyperLink = 'HyperLink',
  AutoSelect = 'AutoSelect',
  HandPickFill = 'HandPickFill',
  WordSuggest = 'WordSuggest',
  Warning = 'Warning',
  Register = 'Register',
  Copy = 'Copy',
  Profits = 'Profits',
  QuestionHelp = 'QuestionHelp',
  PersonLine = 'PersonLine',
  ClockRefill = 'ClockRefill',
  MemoryHelper = 'MemoryHelper',
  Rename = 'Rename',
}

// SVG Line Icons
export const svgIcons = {
  JOYAJOYLogoHome: JOYAJOYLogoHomeIcon,

  PuzzleJOY: PuzzleJOYIcon,
  TextJOY: TextJOYIcon,
  //
  Region: RegionIcon,
  Member: MemberIcon,
  Friend: FriendIcon,
  MembershipTier: MembershipTierIcon,
  //
  GamifiedPost: GamifiedPostIcon,
  BubbleShape: BubbleShapeIcon,
  BubbleShapeShow: BubbleShapeShowIcon,
  //
  Arrow: ArrowIcon,
  Triangle: TriangleIcon,
  Referral: ReferralIcon,
  GameInstruction: GameInstructionIcon,
  Setting: SettingIcon,
  MiniTarget: MiniTargetIcon,
  More: MoreIcon,
  RecentArrow: RecentArrowIcon,
  Share: ShareIcon,
  SuggestedWord: SuggestedWordIcon,
  SuperTarget: SuperTargetIcon,
  Score: ScoreIcon,
  SignUp: SignUpIcon,
  Logout: LogoutIcon,
  Timer: TimerIcon,
  //
  JOYChess: GameTypeJoychessIcon,
  FiveLoavesTwoFish: GameTypeFiveLoavesTwoFishIcon,
  TicTacToe: GameTypeTicTacToeIcon,
  Gomoku: GameTypeGomokuIcon,
  Conversion: GameConversionIcon,
  //
  Ai: AiIcon,
  Gurantee: GuranteeIcon,
  Star: StarIcon,
  BookGame: BookGameIcon,
  QuickMemoryJoy: QuickMemoryJoyIcon,
  SpellingJoy: SpellingJoyIcon,
  WritingJoy: WritingJoyIcon,
  GameTypeSyllable: GameTypeSyllableIcon,
  GameTypeFingerWritingComponent: GameTypeFingerWritingComponentIcon,
  GameTypeFingerWritingStroke: GameTypeFingerWritingStrokeIcon,
  GameTypeFingerWritingClickComponent: GameTypeFingerWritingClickComponentIcon,
  ScoreAnalysis: ScoreAnalysisIcon,
  Translation: TranslationIcon,
  TTS: TTSIcon,
  Upgrade: UpgradeIcon,
  SubscriptionUpgrade: SubscriptionUpgradeIcon,
  Improve: ImproveIcon,
  Family: FamilyIcon,
  Cash: CashIcon,
  Happy: HappyIcon,
  Person: PersonIcon,
  //
  BrainX9: BrainX9Icon,
  LanguageA: LanguageAIcon,
  LanguageQ: LanguageQIcon,
  OCRScan: OCRScanIcon,
  Camera: CameraIcon,
  Picture: PictureIcon,
  Edit: EditIcon,
  Click: ClickIcon,
  SelectAll: SelectAllIcon,
  SelectSuggest: SelectSuggestIcon,
  TutorGames: TutorGamesIcon,
  Journey: JourneyIcon,
  Arrow5: Arrow5Icon,
  BubbleIndicator: BubbleIndicatorIcon,
  SquareCheckboxEmpty: SquareCheckboxEmptyIcon,
  SquareCheckboxTick: SquareCheckboxTickIcon,
  CircleCheckboxTick: CircleCheckboxTickIcon,
  Tick: TickIcon,
  CircleCheckboxEmpty: CircleCheckboxEmptyIcon,
  CircleCross: CircleCrossIcon,
  DirectArrow: DirectArrowIcon,
  MemoryWithAI: MemoryWithAIIcon,
  MemoryWithoutAI: MemoryWithoutAIIcon,
  Play: PlayIcon,
  Period: PeriodIcon,
  PlayerPause: PlayerPauseIcon,
  PlayerPlay: PlayerPlayIcon,
  PlayerStop: PlayerStopIcon,
  DoubleClock: DoubleClockIcon,
  DoubleScore: DoubleScoreIcon,
  CircleBack: CircleBackIcon,
  Game: GameIcon,
  CircleTickBlue: CircleTickBlueIcon,
  CircleTick: CircleTickIcon,
  ConfirmTick: ConfirmTickIcon,
  RedCross: RedCrossIcon,
  DoublePerson: DoublePersonIcon,
  Retry: RetryIcon,
  Repeat: RepeatIcon,
  Rotate: RotateIcon,
  Crop: CropIcon,
  Move: MoveIcon,
  MagnifyingMinus: MagnifyingMinusIcon,
  MagnifyingPlus: MagnifyingPlusIcon,
  PreviewHide: PreviewHideIcon,
  PreviewShow: PreviewShowIcon,
  Content: ContentIcon,
  Cross: CrossIcon,
  JOYCashWeb: JOYCashWebIcon,
  Headphone: HeadphoneIcon,
  JoyStation: JoyStationIcon,
  SearchWhite: SearchWhiteIcon,
  Classroom: ClassroomIcon,
  ScrollArrow: ScrollArrowIcon,
  Phone: PhoneIcon,
  ConvertBook: ConvertBookIcon,
  RubbishBin: RubbishBinIcon,
  Lock: LockIcon,
  WebStoreBasket: WebStoreBasketIcon,
  ReferralRole: ReferralRoleIcon,
  Brain: BrainIcon,
  Clock: ClockIcon,
  ProgressArrow: ProgressArrowIcon,
  Complete: CompleteIcon,
  ScoreA: ScoreAIcon,
  PracticeTick: PracticeTickIcon,
  Bible: BibleIcon,
  BibleLine: BibleLineIcon,
  WebHome: WebHomeIcon,
  Wallet: WalletIcon,
  Subscription: SubscriptionIcon,
  Storage: StorageIcon,
  BreadDonate: BreadDonateIcon,
  HyperLink: HyperLinkIcon,
  AutoSelect: AutoSelectIcon,
  HandPickFill: HandPickFillIcon,
  WordSuggest: WordSuggestIcon,
  Warning: WarningIcon,
  Register: RegisterIcon,
  Copy: CopyIcon,
  Profits: ProfitsIcon,
  QuestionHelp: QuestionHelpIcon,
  PersonLine: PersonLineIcon,
  ClockRefill: ClockRefillIcon,
  MemoryHelper: MemoryHelperIcon,
  Rename: RenameIcon,
};

export type SVGIconName = keyof typeof svgIcons;
